import { LocalStorageKeys } from '../constants/localStorage';

/**
 * Migrates localStorage values from plain string format to JSON format
 * This is needed because useLocalStorage expects JSON-serialized values
 */
export const migrateLocalStorage = (): void => {
  // Migrate EULA_ACCEPTED if it exists as plain string
  const eulaValue = window.localStorage.getItem(LocalStorageKeys.EULA_ACCEPTED);
  if (eulaValue) {
    try {
      JSON.parse(eulaValue);
      // Already in JSON format
    } catch {
      // Old plain-string format, migrate it
      window.localStorage.setItem(LocalStorageKeys.EULA_ACCEPTED, JSON.stringify(eulaValue));
    }
  }

  // Note: OIDC_KEY and VALID_HOSTS are still set as plain strings in index.tsx
  // and read as plain strings in api.ts, so they don't need migration
};
